import { computed, reactive } from 'vue'
import {
  IContact,
  SelectOptions,
  DripModeInfo,
  RSSEmailCampaignInfo,
} from '../types'
import { useDateFormat } from '../composable/filters'
import { WEEK_DAYS, getRecurringPeriodMenuOptions } from '../util/const_values'
import dayjs from 'dayjs'

const RECURRING_PERIODS = getRecurringPeriodMenuOptions()
export const bulkActionsState = reactive({
  editMode: false,
  contacts: [] as IContact[] | String,
  type: 'send-now',
  date: useDateFormat().dateNow(),
  time: '10:00 AM',
  selectedTag: [] as Array<String>,
  selectedSmartList: [],
  totalContactHit: 0,
  dripModeData: {
    startOnDate: useDateFormat().dateNow('YYYY-MM-DD HH:mm', { addMin: 5 }),
    selectedAfterUnit: 'hours',
    startFromTime: 'none',
    endAtTime: 'none',
    sendDays: [...WEEK_DAYS],
  } as DripModeInfo,
  rssEmailMode: {
    rssFeedURL: '',
    recurringPeriod: RECURRING_PERIODS[0].value,
    startAtTime: '10:00 AM',
    sendDays: [...WEEK_DAYS],
    rssFeedURLErrorMessage: '',
    name: 'RSS Email Campaign',
    startAtDay: '1',
    startAtMonthDay: String(dayjs().date()),
  } as RSSEmailCampaignInfo,
})
export function useBulkAction() {
  const bulkActionName = computed(() => {
    let name =
      bulkActionsState.type === 'send-now'
        ? 'Review and send'
        : bulkActionsState.type === 'schedule'
        ? 'Review and schedule'
        : 'Review and Send'
    if (bulkActionsState.editMode) {
      name = name.replace('Send', 'Update').replace('schedule', 'Update')
    }
    return name
  })

  return {
    bulkActionName,
  }
}
